import { Component, HostListener } from '@angular/core';
import { LanguageService, SupportedLanguage } from '../../services/language.service';

@Component({
  selector: 'tremaze-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent {
  isDropdownOpen = false;

  constructor(public languageService: LanguageService) {}

  /**
   * Togglet das Dropdown
   */
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
   * Setzt die ausgewählte Sprache und schließt das Dropdown
   */
  onLanguageChange(language: SupportedLanguage): void {
    this.languageService.setLanguage(language);
    this.isDropdownOpen = false;
    window.location.reload();
  }

  /**
   * Schließt das Dropdown beim Klick außerhalb
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.language-switcher');
    if (!clickedInside && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }

  /**
   * Gibt den angezeigten Namen für eine Sprache zurück
   */
  getLanguageLabel(language: SupportedLanguage): string {
    const labels: Record<SupportedLanguage, string> = {
      de: 'Deutsch',
      en: 'English',
      ar: 'العربية',
      es: 'Español',
      fr: 'Français',
      it: 'Italiano',
      pl: 'Polski',
      ro: 'Română',
      ru: 'Русский',
      tr: 'Türkçe',
      uk: 'Українська',
    };
    return labels[language];
  }

  /**
   * Gibt das Flag-Emoji für eine Sprache zurück (optional)
   */
  getLanguageFlag(language: SupportedLanguage): string {
    const flags: Record<SupportedLanguage, string> = {
      de: '🇩🇪',
      en: '🇬🇧',
      ar: '🇸🇦',
      es: '🇪🇸',
      fr: '🇫🇷',
      it: '🇮🇹',
      pl: '🇵🇱',
      ro: '🇷🇴',
      ru: '🇷🇺',
      tr: '🇹🇷',
      uk: '🇺🇦',
    };
    return flags[language];
  }
}
